module.exports = __webpack_public_path__ + "img/ceviche_de_concha_negra.352324ee.jpg";